export default __webpack_public_path__ + "static/dacha-property-2-f115803e541d9d0b2f183fba32d54bed.png";